// Backend legacy timestamps without an offset are treated as Nigeria local time.
// New endpoints should always return UTC timestamps with Z or an explicit offset.
export function parseDateTime(value?: string|null): Date | undefined {
 if(!value||value.startsWith("0001-"))return undefined;
 const normalized=/^\d{4}-\d{2}-\d{2}T/.test(value)&&!/(Z|[+-]\d{2}:?\d{2})$/i.test(value)?value+"+01:00":value;
 const date=new Date(normalized);return Number.isNaN(date.getTime())?undefined:date;
}
export function formatDateTime(value?:string|null):string{return parseDateTime(value)?.toLocaleString("en-NG",{timeZone:"Africa/Lagos"})??"Not recorded";}
export function localDateTimeInput(value?:string|null):string{const date=parseDateTime(value);if(!date)return "";const adjusted=new Date(date.getTime()-date.getTimezoneOffset()*60000);return adjusted.toISOString().slice(0,16);}
